/**
 * LazySqlEditor — leniwie ładowany `SqlEditor` (CodeMirror nie trafia do głównego bundla).
 * Na czas ładowania pokazuje szkielet o tej samej wysokości.
 */

import { forwardRef, lazy, Suspense } from 'react';

import { Skeleton } from '@/components/Skeleton';

import type { SqlEditorHandle, SqlEditorProps } from './SqlEditor';

const SqlEditorImpl = lazy(() => import('./SqlEditor'));

export const LazySqlEditor = forwardRef<SqlEditorHandle, SqlEditorProps>(
  function LazySqlEditor(props, ref) {
    return (
      <Suspense
        fallback={
          <Skeleton
            className="w-full"
            style={{ height: props.height ?? props.minHeight ?? '160px' }}
          />
        }
      >
        <SqlEditorImpl ref={ref} {...props} />
      </Suspense>
    );
  },
);

export type {
  SqlEditorCompletion,
  SqlEditorDiagnostic,
  SqlEditorHandle,
  SqlEditorProps,
} from './SqlEditor';
